var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { util } from '@joint/plus';
import { Node, calculateHeight } from '../node';
export class Division extends Node {
    defaults() {
        const defaults = super.defaults();
        return util.defaultsDeep({
            type: 'processor.Division',
            name: 'Div',
            group: 'math',
            size: {
                width: 120,
                height: calculateHeight(2)
            },
            inputSettings: [{
                    name: 'A',
                    type: 'number',
                    property: 'a',
                    defaultValue: 0
                }, {
                    name: 'B',
                    type: 'number',
                    property: 'b',
                    defaultValue: 0
                }],
            outputSettings: [{
                    name: 'Result',
                    type: 'number',
                }]
        }, defaults);
    }
    action() {
        return __awaiter(this, void 0, void 0, function* () {
            const { a, b } = this.properties;
            const result = a / b;
            this.set('result', result);
            return [result];
        });
    }
    getInspectorConfig() {
        const nodeConfig = super.getInspectorConfig();
        return util.defaultsDeep({
            groups: {
                division: {
                    label: 'Division',
                    index: 2
                }
            },
            inputs: {
                result: {
                    type: 'number',
                    label: 'Result',
                    group: 'division',
                    attrs: {
                        '.number': {
                            disabled: true
                        }
                    }
                },
            }
        }, nodeConfig);
    }
}
